import { modes } from '@/components/changeRequests/propertyRenderer'
import React from 'react'
import Resx from '@/components/Resx'
import { ApprovalBadges } from '@/components/changeRequests/approvalBadges'

export function getBadges (mode, data, tabs) {
  let approvals = data.get('approvalInfo')
  if (mode === modes.edit && approvals) {
    approvals = approvals.filter(v => typeof v === 'boolean')
  }
  return approvals && approvals.size > 0
    ? tabs.map(tab => {
      if (typeof tab.badge === 'string') {
        const excludeRegex = new RegExp(tab.exclude)
        const approvalPart = tab.badge.length === 0
          ? approvals.filter((v, k) => !k.includes('.') && !k.includes('[') && !excludeRegex.test(k))
          : approvals.filter((v, k) => k.startsWith(tab.badge))
        tab.badge = {
          rejected: approvalPart.filter(v => v === false).size,
          approved: approvalPart.filter(v => v === true).size,
          pending: approvalPart.filter(v => typeof v !== 'boolean').size
        }
        tab.text = <React.Fragment>
          <span><Resx name={tab.text} /></span>
          <ApprovalBadges badges={tab.badge} mode={mode} />
        </React.Fragment>
      }
      return tab
    })
    : tabs
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/badgeUtils.js